import React from 'react';
import styles from './ToggleUseTheFact.module.scss'
import { Switch, Icon, Typography } from 'antd';
import cn from 'classnames';

const { Text } = Typography;

export const ToggleUseTheFact = ({ enabled, onChange }) => {
  return (
    <div className={cn(styles.root)}>
      <Switch
        checkedChildren={<Icon type="check" />}
        unCheckedChildren={<Icon type="close" />}
        checked={enabled}
        onChange={onChange}
      />
      <Text className={cn(styles.text, { [styles.active]: enabled })}>
        Фактически закрытые заявки
      </Text>
    </div>
  )
}